// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationComponent_pagination__DuDVG","active":"PaginationComponent_active__gmZB+","disable":"PaginationComponent_disable__9Xnax"};